import fetchApi from '../../Services/requests';
import { CreditListUrl } from '../../Routes/credits.route';
import { removeDuplicatesFromArray } from '../../Utils/common.util';
import { CreditRequestBodyType } from '../../Types/credits.type';

export const getCreditListAction = async (
  set,
  type: string,
  body: CreditRequestBodyType,
  isFilterChanged = false
): Promise<number> => {
  set((state) => ({
    [`${type}CreditListData`]: isFilterChanged
      ? []
      : state[`${type}CreditListData`],
    creditsListLoading:
      (state[`${type}CreditListData`].length === 0 || isFilterChanged) && true,
    creditsListError: false
  }));

  const response = await fetchApi(CreditListUrl(), {
    ...body,
    activityType: type
  });

  if (response?.ok) {
    set((state) => ({
      [`${type}CreditListData`]: removeDuplicatesFromArray(
        state[`${type}CreditListData`].concat(response.data || null)
      ),
      creditsListLoading: false,
      creditsListError: true
    }));
    return response.data.length;
  } else {
    set((state) => ({
      [`${type}CreditListData`]: state[`${type}CreditListData`],
      creditsListLoading: false,
      creditsListError: true
    }));
    return null;
  }
};

export const setHasMoreDataAction = (
  set,
  hasMore: {
    active: boolean;
    expired: boolean;
    used: boolean;
  }
): void => {
  set({ hasMoreData: hasMore });
};
